/**
 * AppConfig -- Centralized configuration for the panel.
 * Replaces all window.__* globals from v2.1.
 *
 * Dev  = http://localhost:5258 (API local directa)
 * Prod = '' (proxy Vite → api.nexodigital360.com, evita CORS)
 *
 * @module config
 */

const STORAGE_KEYS = {
  AUTH_TOKEN: 'nx_auth_token',
  ENV: 'nx_env',
  ROLE: 'nx_role'
};

const API_BASES = {
  dev: 'http://localhost:5258',
  prod: 'https://api.nexodigital360.com'
};

const N8N_BASES = {
  dev: 'http://localhost:5678',
  prod: 'https://n8n.nexodigital360.com'
};

function get(key) {
  return localStorage.getItem(key);
}

function set(key, value) {
  if (value === null || value === undefined) {
    localStorage.removeItem(key);
  } else {
    localStorage.setItem(key, value);
  }
}

export const AppConfig = {
  get apiBase() {
    return API_BASES[this.env] ?? '';
  },

  get n8nBase() {
    return N8N_BASES[this.env] ?? N8N_BASES.prod;
  },

  get token() {
    return get(STORAGE_KEYS.AUTH_TOKEN);
  },

  get isAuthenticated() {
    return !!this.token;
  },

  get storageMode() {
    return this.isAuthenticated ? 'api' : 'memory';
  },

  get env() {
    return get(STORAGE_KEYS.ENV) || 'prod';
  },

  setEnv(env) {
    set(STORAGE_KEYS.ENV, env);
  },

  setToken(token) {
    set(STORAGE_KEYS.AUTH_TOKEN, token);
  },

  login(token, env) {
    this.setToken(token);
    if (env) this.setEnv(env);
  },

  logout() {
    set(STORAGE_KEYS.AUTH_TOKEN, null);
    // El rol tambien se va (CTX-M2-09). Se quedaba pegado en localStorage, asi
    // que el siguiente que entrara en ese equipo heredaba el rol del anterior.
    set(STORAGE_KEYS.ROLE, null);
  },

  get role() {
    // Por defecto, el MENOS poderoso. Antes era 'dev': cualquiera que entrara
    // sin rol guardado veia el panel completo. Los roles reales los escribe
    // AuthService con lo que responde la API al entrar.
    return get(STORAGE_KEYS.ROLE) || 'member';
  },

  setRole(role) {
    set(STORAGE_KEYS.ROLE, role);
  },

  clear() {
    Object.values(STORAGE_KEYS).forEach(k => localStorage.removeItem(k));
  },

  API_BASES,
  N8N_BASES
};
